/**
 * utils/connectionPool/config.ts — environment-based pool config
 */

import type { PoolConfig } from './types.js';

/**
 * Global pool configuration for production
 */
export const getProductionPoolConfig = (): PoolConfig => {
    return {
        maxConnections: 20, // For production with multiple requests
        minConnections: 5, // Maintain 5 warm connections
        idleTimeout: 30 * 60 * 1000, // 30 minutes
        acquireTimeout: 10 * 1000, // 10 seconds
    };
};

/**
 * Global pool configuration for development
 */
export const getDevelopmentPoolConfig = (): PoolConfig => {
    return {
        maxConnections: 5,
        minConnections: 1,
        idleTimeout: 10 * 60 * 1000, // 10 minutes
        acquireTimeout: 5 * 1000, // 5 seconds
    };
};

/**
 * Get appropriate pool config based on environment
 */
export const getPoolConfig = (): PoolConfig => {
    return import.meta.env.PROD
        ? getProductionPoolConfig()
        : getDevelopmentPoolConfig();
};
